<template>
  <div class="model-content">
    <el-image
      class="content-img"
      :src="url"
      fit="fill"
    ></el-image>
    <div class="content-body">
      <h2>{{ title }}</h2>
      <div class="description" v-html="desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgDescription',
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/content/ImgDescription/index.vue